<template>
  <div
    class="rodo"
    v-if="rodoIsOn"
  >
    <div class="rodo__content">
      <div
        class="rodo__close-modal"
        @click="closeModal"
      >
        x
      </div>
         Używamy cookies w celu gromadzenia danych statystycznych, emisji reklam oraz prawidłowego funkcjonowania niektórych
         elementów serwisu. Pliki te mogą być także umieszczane na Państwa urządzeniach przez współpracujące z nami firmy zewnętrzne.
         Korzystając ze strony wyrażasz zgodę na używanie cookie, zgodnie z aktualnymi ustawieniami przeglądarki. Dowiedz się więcej o <a href="https://www.polskieradio.pl/13/53/Artykul/807900,Polityka-Polskiego-Radia-dotycz%C4%85ca-Ciasteczek" target="_blank">
         celu ich używania</a> i <a href="https://support.google.com/chrome/answer/95647?hl=pl" target="_blank">zmianie ustawień cookie</a> w przeglądarce.
      <br>
      <br>
        25 maja 2018 roku zaczęło obowiązywać Rozporządzenie Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r (RODO).
        Zachęcamy do zapoznania się z informacjami dotyczącymi przetwarzania danych osobowych w Portalu PolskieRadio.pl
      <br>
      <br>
        Więcej informacji na ten temat znajdziesz na stronach <a href="https://www.polskieradio.pl/13/6788" target="_blank">dane osobowe</a> oraz <a href="https://www.polskieradio.pl/13/53/Artykul/254368" target="_blank">polityka prywatności</a>.
    </div>
  </div>
</template>

<script>
import mixin from '../mixin.js';
export default {
  mixins: [mixin]
}
</script>

<style lang="scss" scoped>
.rodo {
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: rgba(238, 235, 237, 0.9);
  padding: 1rem 0;
  &__content{
    font-size: 0.7rem;
    font-family: 'Poppins', sans-serif;
    width: 100%;
    max-width: 1400px;
    line-height: 1.4;
    position: relative;
    padding: 0 2.5rem 0 1rem;
    box-sizing: border-box;
    a {
      font-weight: 700;
    }
  }
  &__close-modal {
    position: absolute;
    text-transform: uppercase;
    right: 0.5rem;
    cursor: pointer;
    font-size: 1.4rem;
    top: -0.5rem;
  }
}
</style>
